import React from 'react';

const Plus = () => (
		<svg viewBox="0 0 44 44" className="icon plus">
    	<line x1="22" y1="14" x2="22" y2="30" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
    	<line x1="14" y1="22" x2="30" y2="22" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
		</svg>
		)

export default Plus;



// WEBPACK FOOTER //
// ./src/components/Icons/Plus.js